import React, { useEffect, useState, useCallback } from "react";
import TableComponents from "../../Global Functions/tableComponents";
import { useDispatch, useSelector } from "react-redux";
import {
  listCancellationPolicies,
} from "../../Redux/Actions/cancellationPoliciesAction";
import { columnsCancellationPolicies } from "../../Global Functions/columnsAntd";
import toast from "react-hot-toast";

const ListCancellationPolicies = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50", "100"],
  });
  const [tempSearch, setTempSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const dispatch = useDispatch();

  const fetchDetails = useCallback(
    (page, limit, showLoader = true) => {
      const payload = {
        page,
        limit,
        is_deleted: false,
        search: searchQuery,
      };
      dispatch(listCancellationPolicies(payload, showLoader)).catch(() => {
        if (!showLoader) {
          toast.error("Failed to refresh cancellation policies list");
        }
      });
    },
    [dispatch, searchQuery]
  );

  useEffect(() => {
    fetchDetails(pagination.current, pagination.pageSize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.current, pagination.pageSize, fetchDetails]);

  // Reading cancellation policies state from cancellationPoliciesReducer
  const cancellationPolicies = useSelector((state) => state.cancellationPolicies?.policies || {});
  const loading = useSelector((state) => state.cancellationPolicies?.loading);

  useEffect(() => {
    if (cancellationPolicies?.total) {
      setPagination((prevData) => ({
        ...prevData,
        total: cancellationPolicies.total, // note: use total per your API response
      }));
    }
  }, [cancellationPolicies]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
    fetchDetails(pagination.current, pagination.pageSize);
  };

  const filterHandler = () => {
    setSearchQuery(tempSearch);
    setPagination((prev) => ({ ...prev, current: 1 }));
  };

  return (
    <TableComponents
      h3heading="Cancellation Policies List"
      pagination={pagination}
      onChange={handleTableChange}
      columns={columnsCancellationPolicies(canEdit)}
      buttonhead2={canAdd ? "Add Cancellation Policy" : null}
      navigateTo2={canAdd ? "/cancellation_policies/add" : null}
      dataSource={
        Array.isArray(cancellationPolicies.data) ? cancellationPolicies.data : []
      }
      loading={loading}
      setState={setTempSearch}
      filterFunction={filterHandler}
    />
  );
};

export default ListCancellationPolicies;
